<template>
  <!-- <vue-editor v-model="noteContent" @text-change="saveNote" :editor-toolbar="editorToolbar"></vue-editor> -->
  <!-- <div class="collapse-column-left border-right"> -->
  <!-- <ul class="nav nav-tabs nav-fill"
        id="myTab"
        role="tablist">
      <li class="nav-item"
          role="presentation">
        <a class="nav-link active"
           id="my-note-tab"
           data-toggle="tab"
           href="#my-note"
           role="tab"
           aria-controls="my-note"
           aria-selected="true">我的笔记</a>
      </li>
      <li class="nav-item"
          role="presentation">
        <a class="nav-link"
           id="other-note-tab"
           data-toggle="tab"
           href="#other-note"
           role="tab"
           aria-controls="other-note"
           aria-selected="false">同学笔记</a>
      </li>
    </ul>-->
  <div class="tab-content flex-grow-1 overflow-auto" id="myTabContent">
    <div
      class="tab-pane fade bg-dark h-100 active show"
      id="my-note"
      role="tabpanel"
      aria-labelledby="my-note-tab"
      style="position: absolute; width: 100%"
    >
      <div class="d-flex flex-column h-100">
        <div class="resizable-component bili-note">
          <div class="note-drag-bar drag-el">
            <div class="status-bar">
              <div class="status-bar--content status-bar--info">
                <!---->
                <!---->
                <span class="text" v-if="c_isShowHint">
                  <span class="text-msg" title="在下方输入文字做笔记"
                    >在下方输入文字做笔记</span
                  >
                </span>
                <template v-if="!c_isShowHint">
                  <span
                    class="text"
                    v-if="
                      fetchedNoteContent &&
                      isNoteFetched &&
                      !isNoteSaving &&
                      !isNoteSaved
                    "
                  >
                    <span class="text-msg" title="笔记内容加载完成"
                      >笔记内容加载完成</span
                    >
                  </span>
                  <span class="text" v-if="isNoteSaving">
                    <span class="text-msg" title="自动保存中">自动保存中</span>
                  </span>
                  <span class="text" v-if="isNoteSaved">
                    <span class="text-msg" title="自动保存成功"
                      >自动保存成功</span
                    >
                    <span>{{ dateNoteSaved }}</span>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="notepad flex-grow-1 h-100">
          <textarea
            style="position: absolute; top: 28px; bottom: 0; width: 100%"
            v-model="noteContent"
            @input="saveNote"
            :readonly="!editable"
          ></textarea>
        </div>
        <!-- <div class="bg-light py-2 px-3 border-top ">
            <div class="custom-control custom-switch">
              <input type="checkbox"
                     class="custom-control-input"
                     v-model="turnOnShare"
                     @change="onShareChange()"
                     id="customSwitch1" />
              <label class="custom-control-label small pt-1"
                     for="customSwitch1">公开这篇笔记</label>
            </div>
          </div>-->
      </div>
    </div>
    <!-- 同学笔记 -->
    <!-- <div class="tab-pane fade"
           id="other-note"
           role="tabpanel"
           aria-labelledby="other-note-tab">

        <div class="list-group list-group-flush">
          <a href="#"
             class="list-group-item list-group-item-action ">
            <div class="media">
              <div class="d-flex align-self-bottom">
                <img class="rounded-circle mr-3"
                     src="../../../../assets/img/avatar.png"
                     width="32"
                     height="32" />
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <small>品小职</small>·<small class="text-secondary">2天前</small>
                </div>
                <div class="line-clamp-5 small">重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险</div>
              </div>
            </div>
          </a>
          <a href="#collapseExample"
             data-toggle="collapse"
             role="button"
             aria-expanded="false"
             aria-controls="collapseExample"
             class="list-group-item list-group-item-action ">
            <div class="media">
              <div class="d-flex align-self-bottom">
                <img class="rounded-circle mr-3"
                     src="../../../../assets/img/avatar.png"
                     width="32"
                     height="32" />
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <small>品小职</small>·<small class="text-secondary">2天前</small>
                </div>
                <div class="line-clamp-5 small">重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险</div>
              </div>
            </div>
          </a>
          <a href="#collapseExample"
             data-toggle="collapse"
             role="button"
             aria-expanded="false"
             aria-controls="collapseExample"
             class="list-group-item list-group-item-action ">
            <div class="media">
              <div class="d-flex align-self-bottom">
                <img class="rounded-circle mr-3"
                     src="../../../../assets/img/avatar.png"
                     width="32"
                     height="32" />
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <small>品小职</small>·<small class="text-secondary">2天前</small>
                </div>
                <div class="line-clamp-5 small">重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险</div>
              </div>
            </div>
          </a>
          <a href="#collapseExample"
             data-toggle="collapse"
             role="button"
             aria-expanded="false"
             aria-controls="collapseExample"
             class="list-group-item list-group-item-action ">
            <div class="media">
              <div class="d-flex align-self-bottom">
                <img class="rounded-circle mr-3"
                     src="../../../../assets/img/avatar.png"
                     width="32"
                     height="32" />
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <small>品小职</small>·<small class="text-secondary">2天前</small>
                </div>
                <div class="line-clamp-5 small">重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险</div>
              </div>
            </div>
          </a>
          <a href="#collapseExample"
             data-toggle="collapse"
             role="button"
             aria-expanded="false"
             aria-controls="collapseExample"
             class="list-group-item list-group-item-action ">
            <div class="media">
              <div class="d-flex align-self-bottom">
                <img class="rounded-circle mr-3"
                     src="../../../../assets/img/avatar.png"
                     width="32"
                     height="32" />
              </div>
              <div class="media-body">
                <div class="mb-2">
                  <small>品小职</small>·<small class="text-secondary">2天前</small>
                </div>
                <div class="line-clamp-5 small">重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险</div>
              </div>
            </div>
          </a>
        </div>
      </div>-->
  </div>

  <!-- <div class="other-note-detail collapse" id="collapseExample">
      <div class="d-flex flex-column h-100">
        <header class="border-bottom bg-white py-1">
          <a
            href="#collapseExample"
            data-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample"
            class="btn btn-link text-info d-flex align-items-center"
          >
            <i class="pz-icon icon-chevron-left"></i>
            <small>同学笔记</small>
          </a>
        </header>
        <div class="p-4 overflow-auto flex-grow-1">
          <p>
            重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险
          </p>
          <p>
            重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险
          </p>
          <p>
            重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险重大错报风险是指如果存在某一错报，该错报单独或连同其他错报可能是重大的，注册会计师为将审计风险降至可接受的低水平而实施程序后没有发现这种错报的风险
          </p>
        </div>
      </div>
    </div>
  </div> -->
</template>
<script>
//import { VueEditor } from 'vue2-editor';
import { debounce } from 'lodash';

import { /* EDITOR_TOOL_BAR, */ DEBOUNCE_LATENCY } from '../../constants';
import { fetchQuestionNote, updateQuestionNote } from '../../global/service';

export default {
  props: {
    Question: Object,

    Q: Object,

    onNoteSaved: {
      type: Function,
      default: () => {},
    },
  },

  components: {
    //VueEditor,
  },

  data() {
    return {
      noteContent: '',
      fetchedNoteContent: '',
      //editorToolbar: EDITOR_TOOL_BAR,
      editable: false,
      isNoteFetched: false,
      isNoteSaving: false,
      isNoteSaved: false,
      dateNoteSaved: '',
      share: false,
    };
  },

  computed: {
    QuestionId() {
      return this.Question.questionId;
    },

    c_isShowHint() {
      return this.editable && !this.noteContent;
    },

    turnOnShare: {
      get: function () {
        // await this.saveNote();
        return this.share;
      },
      set: function (turnOnShare) {
        this.share = turnOnShare;
        // this.saveNote();
      },
    },
  },

  async created() {
    this.editable = false;
    this.saveNote = debounce(this.saveNote, DEBOUNCE_LATENCY);
    await this.fetchNote(this.QuestionId);
    this.isNoteFetched = true;
    this.editable = true;
  },

  beforeDestroy() {
    this.editable = false;
    this.saveNote.flush();
  },

  watch: {
    async QuestionId(id1, id2) {
      if (id1 !== id2) {
        this.editable = false;
        const prm2 = this.saveNote.flush();
        this.isNoteFetched = false;
        this.fetchedNoteContent = '';
        const prm1 = this.fetchNote(id1);
        await prm2;
        await prm1;
        this.isNoteFetched = true;
        this.isNoteSaving = false;
        this.isNoteSaved = false;
        this.editable = true;
      }
    },
  },

  methods: {
    async saveNote() {
      // console.log(this.Q);
      //if (this.editable) {
      this.isNoteSaving = true;
      this.isNoteSaved = false;
      this.onNoteSaved({
        Question: this.Q,
        flag: this.noteContent ? true : false,
      });
      const promiseUpdateQuestionNote = updateQuestionNote({
        questionId: this.Question.questionId,
        content: this.noteContent,
        groupId: this.Question.groupId,
        courseId: this.Question.courseId,
        share: this.share,
      });
      await promiseUpdateQuestionNote;
      const date = new Date();
      this.dateNoteSaved = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}`;
      this.dateNoteSaved += ` ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      this.isNoteSaving = false;
      this.isNoteSaved = true;
      return promiseUpdateQuestionNote;
      //}
      //this.editable = true;
    },
    onShareChange() {
      this.saveNote();
    },
    async fetchNote(id) {
      //this.editable = false;
      const prm = fetchQuestionNote(id);
      const res = await prm;
      //if (!res.data.data.content && !this.noteContent) {
      //  this.editable = true;
      //}
      this.noteContent = res.data.data.content;
      this.fetchedNoteContent = this.noteContent;
      this.share = res.data.data.share;
      return prm;
    },
  },
};
</script>
<style scoped lang="scss">
.resizable-component.resizable-component {
  height: auto;
}
</style>
